/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const mastercard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M6.658 7.5A4.229 4.229 0 0 0 6.676 9M8 5.07a4.2 4.2 0 1 1 0 6.261m0-6.262a4.2 4.2 0 1 0 0 6.261m0-6.26A4.19 4.19 0 0 1 9.4 8.2 4.19 4.19 0 0 1 8 11.33"
    />
  </svg>
)
export default mastercard
